import { render, staticRenderFns } from "./oatManagement.vue?vue&type=template&id=e98874aa&scoped=true"
import script from "./oatManagement.vue?vue&type=script&lang=js"
export * from "./oatManagement.vue?vue&type=script&lang=js"
import style0 from "./oatManagement.vue?vue&type=style&index=0&id=e98874aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98874aa",
  null
  
)

export default component.exports